import React, { FC } from 'react';

import { ValuationsTimelineStepperProps } from './types';

const ValuationTimelineStepper: FC<ValuationsTimelineStepperProps> = ({
  children,
  hideLine = false
}) => {
  return (
    <div className="flex w-full">
      <div className="flex flex-col items-center">
        <div className="w-8 h-8 rounded-[50%] border-[1px] border-greySilver" />
        {!hideLine && (
          <div
            className="w-[1px]  bg-greySilver"
            style={{ height: 'calc(100% - 32px)' }}
          />
        )}
      </div>

      <div className="ml-8 w-full ">{children}</div>
    </div>
  );
};

export default ValuationTimelineStepper;
